import { render } from "./PsiholoskeProcene.vue?vue&type=template&id=ff1081ca&scoped=true&lang=html"
import script from "./PsiholoskeProcene.vue?vue&type=script&lang=js"
export * from "./PsiholoskeProcene.vue?vue&type=script&lang=js"

import "./PsiholoskeProcene.vue?vue&type=style&index=0&id=ff1081ca&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-ff1081ca"

export default script